var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteDefault2828 = function SvgDeleteDefault2828(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949596",
    d: "m22.167 7.478-1.645-1.645L14 12.355 7.478 5.833 5.833 7.478 12.355 14l-6.522 6.522 1.645 1.645L14 15.645l6.522 6.522 1.645-1.645L15.645 14z"
  })));
};
export default SvgDeleteDefault2828;